import BookingFormInstructions, {
  FormData as FormDataExport,
} from './BookingFormInstructions';

export type FormData = FormDataExport;
export default BookingFormInstructions;
